// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1roBn","search":"Settings_search__30p3-","filter":"Settings_filter__1ChSs"};